import { Outlet } from 'react-router-dom'

const Identity = () => <Outlet />

export default Identity
